/**
 * Punkt 41 (Antoine, 26.09.2026): die Kommunikationssprache eines Vorgangs (`events.offer_language`)
 * steuert Angebot, Gast-Mails, Erinnerungen, Rechnungsmails, Nachfassen und Storno.
 *
 * EINE Liste fuer Backend (Zod, Rechnung) und Oberflaeche (Sprachwahl). Die Datenbank spiegelt sie
 * in `public.kommunikationssprachen()` (sql/528) — die Ratsche
 * `apps/api/test/kommunikationssprache.test.ts` haelt beide gleich. Eine neue Sprache = hier
 * eintragen + die SQL-Funktion in einer Migration neu definieren. Nur de/en sind freigegeben:
 * jede weitere Sprache braucht eigene, vom Betrieb freigegebene Texte.
 */
export const KOMMUNIKATIONSSPRACHEN = ["de", "en"] as const;
export type Kommunikationssprache = (typeof KOMMUNIKATIONSSPRACHEN)[number];

export const SPRACH_LABEL: Record<Kommunikationssprache, string> = {
  de: "Deutsch",
  en: "English",
};

/**
 * Sprachen, in denen eine ANFRAGE eingehen und ihre Eingangsbestaetigung beantwortet werden darf
 * (Reisegruppen-Widget). Bewusst getrennt von `KOMMUNIKATIONSSPRACHEN`: it/fr werden in
 * `inquiries.language` gespeichert und bestimmen nur die Eingangsbestaetigung; Angebot, Rechnung,
 * Erinnerungen und Storno bleiben de/en (der Vorgang behaelt `de`, eine Anfrage auf `fr` oder `it`
 * setzt ihn auf `en` — F7 sql/698, it sql/700). Keine SQL-Spiegelung noetig.
 */
export const ANFRAGESPRACHEN = ["de", "en", "it", "fr"] as const;
export type Anfragesprache = (typeof ANFRAGESPRACHEN)[number];

export function istAnfragesprache(wert: unknown): wert is Anfragesprache {
  return typeof wert === "string" && (ANFRAGESPRACHEN as readonly string[]).includes(wert);
}

export function istKommunikationssprache(wert: unknown): wert is Kommunikationssprache {
  return typeof wert === "string" && (KOMMUNIKATIONSSPRACHEN as readonly string[]).includes(wert);
}

/**
 * Woher der Wert am Vorgang kommt (`events.offer_language_quelle`, CHECK in sql/528).
 * Vorrang: manuell > kunde > anfrage > standard. `bestand` = Vorgang vor Punkt 41 angelegt,
 * Herkunft unbekannt (kein Backfill der Sprache selbst).
 */
export const SPRACH_QUELLEN = ["manuell", "kunde", "anfrage", "standard", "bestand"] as const;
export type SprachQuelle = (typeof SPRACH_QUELLEN)[number];

export const QUELLE_LABEL: Record<SprachQuelle, string> = {
  manuell: "von Hand gesetzt",
  kunde: "beim Kunden gemerkt",
  anfrage: "aus Anfrage erkannt",
  standard: "Standard des Betriebs",
  bestand: "vor Einführung der Sprachwahl festgelegt",
};
